export const PACKS = [
  {
    label: "1 postcard",
    variant: "PackOfOne",
    pricePerCard: 4.99,
    total: 4.99,
  },
  {
    label: "3 postcards",
    variant: "PackOfThree",
    pricePerCard: 4.95,
    total: 14.85,
  },
  {
    label: "10 postcards",
    variant: "PackOfTen",
    pricePerCard: 4.45,
    total: 44.5,
  },
]
